import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import './assets/libs/tobii/js/tobii.min.js'
import './assets/libs/feather-icons/feather.min.js'
import './assets/js/plugins.init.js'
import './assets/js/app.js'
import '@mdi/font/css/materialdesignicons.min.css'

Vue.config.productionTip = false

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')